import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { SnapshotAlarmGroup, CreateSnapshotAlarmGroupDto } from 'types';

export const deleteSnapshotAlarmGroup = ({
  data,
}: {
  data: CreateSnapshotAlarmGroupDto;
}) => {
  return axios.delete(
    `/api/snapshots/${data.snapshot_id}/alarms/${data.alarm_id}/groups`
  );
};

type UseDeleteSnapshotAlarmGroupOptions = {
  alarmId: number;
  config?: MutationConfig<typeof deleteSnapshotAlarmGroup>;
};

export const useDeleteSnapshotAlarmGroup = ({
  alarmId,
  config,
}: UseDeleteSnapshotAlarmGroupOptions) => {
  return useMutation({
    onMutate: async (deletedSnapshotAlarmGroupId) => {
      await queryClient.cancelQueries(['alarms', alarmId, 'groups']);

      const previousSnapshotAlarmGroups = queryClient.getQueryData<
        SnapshotAlarmGroup[]
      >(['alarms', alarmId, 'groups']);

      queryClient.setQueryData(
        ['alarms', alarmId, 'groups'],
        previousSnapshotAlarmGroups?.filter(
          (snapshotAlarmGroup) =>
            snapshotAlarmGroup.snapshot_id !==
            deletedSnapshotAlarmGroupId.data.snapshot_id
        )
      );

      return { previousSnapshotAlarmGroups };
    },
    onError: (_, __, context: any) => {
      if (context?.previousSnapshotAlarmGroups) {
        queryClient.setQueryData(
          ['alarms', alarmId, 'groups'],
          context.previousSnapshotAlarmGroups
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['alarms', alarmId, 'groups']);
    },
    ...config,
    mutationFn: deleteSnapshotAlarmGroup,
  });
};
